import { atom } from 'jotai';

export const isResizingSidebarAtom = atom(false);
